import { z } from 'zod';

// Zod schema for Delivery Invoice form validation
export const DeliveryInvoiceFormSchema = z.object({
  invoiceNumber: z.string().min(1, 'Invoice number is required'),
  clientName: z.string().min(1, 'Client name is required'),
  caseName: z.string().nullable().optional(),
  personServed: z.string().nullable().optional(),
  fileReferenceNumber: z.string().nullable().optional(),
  contactName: z.string().nullable().optional(),
  billingDate: z.date().nullable().optional(),
  totalAmount: z.string().optional(), // Formatted currency string (read-only, auto-calculated)
  status: z.enum(['DRAFT', 'REVIEWED', 'CONFIRMED', 'PAID']).optional(),
});

export type DeliveryInvoiceFormSchemaType = z.infer<typeof DeliveryInvoiceFormSchema>;
